import { Dialog } from "@chakra-ui/react";

import { AnyType } from "./Any.interface";

export interface ModalProps {
  type: string;
  props: AnyType;
  leaveConfirm?: boolean;
  closeOnOverlayClick?: boolean;
  size?: Dialog.RootProps["size"];
  modalContentProps?: AnyType;
}

export enum OverlaySize {
  NORMAL = "normal",
  FULLSCREEN = "fullscreen",
}

export interface OverlayProps {
  title?: string;
  size?: OverlaySize;
  type: string;
  closeOnOverlayClick: boolean;
  leaveConfirm?: boolean;
  props: AnyType;
}
